import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Brain, Sparkles, MessageSquare, Wand2, Lightbulb, Clock } from 'lucide-react';

interface AIChatSignInModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export function AIChatSignInModal({ isOpen, onOpenChange }: AIChatSignInModalProps) {
  const navigate = useNavigate();

  const handleSignIn = () => {
    onOpenChange(false);
    navigate('/auth/signin');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Brain className="h-5 w-5 text-primary" />
            AI-Powered Binaural Beats Assistant
          </DialogTitle>
          <DialogDescription>
            Create personalized sessions with our intelligent AI assistant
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <h4 className="font-medium flex items-center gap-2">
              <Sparkles className="h-4 w-4 text-primary" />
              Premium Features
            </h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-start gap-2">
                <MessageSquare className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
                <span>Natural conversation to design your perfect binaural beats session</span>
              </li>
              <li className="flex items-start gap-2">
                <Wand2 className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
                <span>AI-powered recommendations based on your goals and preferences</span>
              </li>
              <li className="flex items-start gap-2">
                <Lightbulb className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
                <span>Smart suggestions for frequencies, durations, and ambient sounds</span>
              </li>
              <li className="flex items-start gap-2">
                <Clock className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
                <span>Create complex multi-stage sessions with natural language</span>
              </li>
            </ul>
          </div>
          <div className="text-sm text-muted-foreground">
            Sign in to unlock the power of AI-assisted binaural beats creation
          </div>
        </div>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Maybe Later
          </Button>
          <Button onClick={handleSignIn}>
            Sign in to Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
} 